// extracted by mini-css-extract-plugin
export default {"header":"headerback_header__vs-pr","list":"headerback_list__fTlqg","listItem":"headerback_listItem__dEtmq","listContent":"headerback_listContent__lbty9"};